import React from "react"
import { Button, Col, Input, Modal, Row } from "reactstrap"
import { Stack } from "react-bootstrap"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import WeekDay from "components/WeekDay"



/**
 * Responsável pelo balanço financeiro do usuário
 */
class Index extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            weeks: [
                {
                    id: 1,
                    title: "Sab",
                    brand: "Seg."
                },
                {
                    id: 1,
                    title: "Sab",
                    brand: "Ter."
                },
                {
                    id: 1,
                    title: "Sab",
                    brand: "Qua."
                },
                {
                    id: 1,
                    title: "Sab",
                    brand: "Qui."
                },
                {
                    id: 1,
                    title: "Sab",
                    brand: "Sex."
                },
                {
                    id: 1,
                    title: "Sab",
                    brand: "Sab."
                },
                {
                    id: 1,
                    title: "Sab",
                    brand: "Dom."
                },
            ],
            ganhos: [
                {
                    level: 1,
                    value: "R$ 1,00"
                },
                {
                    level: 2,
                    value: "R$ 2,00"
                },
                {
                    level: 3,
                    value: "R$ 3,00"
                },
                {
                    level: 4,
                    value: "R$ 4,00"
                },
                {
                    level: 5,
                    value: "R$ 5,00"
                },
            ]
        }


    }

    componentDidMount() {


    }


    render() {


        return (
            <React.Fragment>
                <div className="d-flex justify-content-center">

                    <Row >
                        <Col sm={12} >
                            <Stack gap={3}>
                                <div className="w-100  p-2 mt-2 ">
                                    <Stack gap={2} className="box-roud-bg-grey-light p-2">
                                        <div><h1 className="text-center card-title font-got-lt-14-300h">Disponível</h1></div>
                                        <div><h1 className="text-center card-title font-got-blk-18-400h">R$ 0,00</h1></div>
                                    </Stack>
                                </div>
                                <div className="w-100">
                                    <h1 className="text-center card-title font-got-lt-14-300h">
                                        SIG - SISTEMA INTEGRADO DE GANHOS
                                    </h1>
                                </div>
                                <div className="m-2">
                                    <Stack gap={2} direction="horizontal">
                                        <div className="w-50  p-2 box-roud-bg-grey-light">
                                            <Stack gap={2}>
                                                <div><h1 className="text-center card-title font-got-lt-14-300h">Acumulado</h1></div>
                                                <div><h1 className="text-center card-title font-got-blk-18-400h">R$ 0,00</h1></div>
                                            </Stack>
                                        </div>
                                        <div className="w-50  p-2 box-roud-bg-grey-light">
                                            <Stack gap={2}>
                                                <div><h1 className="text-center card-title font-got-lt-14-300h">Mês</h1></div>
                                                <div><h1 className="text-center card-title font-got-blk-18-400h">R$ 0,00</h1></div>
                                            </Stack>
                                        </div>
                                    </Stack>
                                </div>

                            </Stack>
                        </Col>
                        <Col sm={12} >
                            <hr className="text-muted mx-2" />
                        </Col>
                        <Col sm={12} className="px-5">
                            <Row>
                                <Col sm={12}>
                                    <Stack gap={2} direction="horizontal">
                                        <div className="w-50"><h1 className="text-start card-title font-got-blk-12-400h">Nível</h1></div>
                                        <div className="w-50"><h1 className="text-end card-title font-got-blk-12-400h">Valor (R$)</h1></div>
                                    </Stack>

                                </Col>

                                {
                                    this.state.ganhos.map((item, index) => {
                                        return (

                                            <Col sm={12} key={index}>
                                                <Stack gap={2} direction="horizontal">
                                                    <div className="w-50"><h1 className="text-start card-title font-got-lt-12-300h ">{item.level}</h1></div>
                                                    <div className="w-50"><h1 className="text-end card-title font-got-lt-12-300h ">{item.value}</h1></div>
                                                </Stack>

                                            </Col>

                                        )

                                    })
                                }


                                <Col sm={12}>
                                    <Stack gap={2} direction="horizontal">
                                        <div className="w-50"><h1 className="text-start card-title font-got-blk-11-300h">Total</h1></div>
                                        <div className="w-50"><h1 className="text-end card-title font-got-lt-14-300h">R$ 15,00</h1></div>
                                    </Stack>
                                </Col>
                            </Row>
                        </Col>
                    </Row>



                </div>
            </React.Fragment>
        )
    }
}

Index.PropTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
    match: PropTypes.any,
    refresh: PropTypes.any,
    loading: PropTypes.any,
    row: PropTypes.any,
    history: PropTypes.object,


}
const mapStateToProps = state => {

    return {}
}
export default withTranslation()(withRouter(connect(mapStateToProps, {

})(
    (Index)
)))
